/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import React from 'react';
import { IHosportsSliderViewProps } from '../../../modules/hosports-slider/./hosports-slider';
//@ts-ignore
import Slider from './../../../baseComponents/slider/./slider';

export default (props: IHosportsSliderViewProps) => {
  let config = props.config;
  console.log(config)
  return (
      <Slider
        dots={config.dots}
        infinite={config.infinite}
        slides={config.slides}
        arrows={config.arrows}
        autoPlay={config.autoPlay}
        height={config.height}
        theme={config.theme}
      />
  );
};
